type TCallback = ((value: number) => void) | undefined;

export const createEmitter = (() => {
  let callback: TCallback;
  return {
    on: (callbackFn: TCallback) => (callback = callbackFn),
    emit: (progress: number) => (callback && callback(progress)),
  };
});
